module.exports = __webpack_public_path__ + "img/Picture12.a9984ea1.jpg";